import axios from '@/utils/axios'

export const getSemiItem = (payload) => {
  return axios.get('/semi_item', {
    params: payload
  })
}

export const getSemiProduceFactory = (id) => {
  return axios.get(`/semi_produce_factory/${id}`)
}

export const createSemiItem = (data) => {
    return axios.post(`/semi_item`, data)
}

export const setSemiItemProdrecipe = (data) => {
    return axios.post(`/set_semi_item_prodrecipe`, data)
}

export const updateSemiItem = (id, data) => {
    return axios.put(`/semi_item/${id}`, data)
}